import React from 'react';

const BENCH = [
  { quote: 'The secret of all good writing is sound judgment.', author: 'Horace', work: 'Ars Poetica' },
  { quote: 'A whole is what has a beginning and middle and end.', author: 'Aristotle', work: 'Poetics' },
  { quote: 'Cut a good story anywhere, and it will bleed.', author: 'Anton Chekhov' },
];

// Craft advice lettered onto the fresco like museum wall text, divided by
// thin gold rules. `row` sets the three side by side; `stack` sets them one
// above another for phones.
export default function PoetsBench({ layout = 'row' }) {
  return (
    <ul className={`bench bench--${layout}`} aria-label="Advice from the Poets' Bench">
      {BENCH.map((entry) => (
        <li key={entry.author} className="bench-inscription">
          <figure>
            <blockquote className="bench-inscription-quote">
              <p>“{entry.quote}”</p>
            </blockquote>
            <figcaption className="bench-inscription-source">
              {entry.author}
              {entry.work && (
                <>
                  {' · '}
                  <cite>{entry.work}</cite>
                </>
              )}
            </figcaption>
          </figure>
        </li>
      ))}
    </ul>
  );
}
